import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { IOwnershipUser } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership';
import { ObjectTypes } from '@fi-shared/types';
import { FiTransferOwnershipHelperService } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-helper.service';

@Component({
    selector: 'fi-transfer-ownership-summary-data',
    templateUrl: './fi-transfer-ownership-summary-data.component.html',
    styleUrl: './fi-transfer-ownership-summary-data.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-transfer-ownership-summary-data' },
    standalone: false,
})
export class FiTransferOwnershipSummaryDataComponent {
    @Input({ required: true }) sourceUser: IOwnershipUser;
    @Input({ required: true }) targetUser: IOwnershipUser;
    @Input({ required: true }) selectedObjectTypes: ObjectTypes[];
    @Input({ required: true }) sourceUserAreaName: string;
    @Input({ required: true }) targetUserAreaName: string;
    @Input() isCompleted: boolean;
    @Input() isDisabled: boolean;

    constructor(private fiTransferOwnershipHelperService: FiTransferOwnershipHelperService) {}

    getContentsSectionHeading(): string {
        return this.isCompleted
            ? 'ownership.completed_section_contents_heading'
            : 'ownership.summary_section_contents_heading';
    }

    getTransferFromLabel(): string {
        return this.isCompleted ? 'ownership.transferred_from' : 'ownership.transfer_from';
    }

    getTransferToLabel(): string {
        return this.isCompleted ? 'ownership.transferred_to' : 'ownership.transfer_to';
    }

    getContentTitle(objectType: ObjectTypes): string {
        const itemsCount: number = this.sourceUser.Ownership[objectType]?.length ?? 0;
        return `${itemsCount} ${this.fiTransferOwnershipHelperService.getContentTitle(objectType, false, itemsCount !== 1)}`;
    }

    protected readonly FiProfileSizes = FiProfileSizes;
}
